import { jsx as m, jsxs as U } from "react/jsx-runtime";
import { forwardRef as N, useRef as $, useCallback as g, useEffect as j } from "react";
import q from "../builders-icons/dist/systems/close.js";
import { useTracking as F } from "../utils.js";
import { Button as K } from "../button/button.js";
import s from "./modal.module.css.js";
import C from "clsx";
const I = "dangerouslyDisableEscape", L = `[tabindex],[contenteditable],:is(select,textarea,input,button):enabled:not(.${s.close})`;
let D = !1;
const T = N(function({
  backdropProps: t,
  children: c,
  className: a,
  closeLabel: w,
  onClose: B,
  open: E = !1,
  size: A = "lg",
  strict: h = !1,
  tracking: _ = !0,
  variant: o = "box",
  ...v
}, M) {
  const O = C(s.backdrop, t == null ? void 0 : t.className), f = $(null), R = C(s.dialog, s[o], s[A], a), x = F(_), i = g(
    (n, l = "_dismiss") => {
      const e = f.current, u = typeof (e == null ? void 0 : e.close) == "function", y = (e == null ? void 0 : e.querySelector("[autofocus]")) || // Split in 3 calls to prioritize autofocus
      (e == null ? void 0 : e.querySelector(L)) || // Then prioritize interactive elements except close button
      (e == null ? void 0 : e.querySelector(`.${s.close}`));
      !e || e.hidden !== n || (u ? e[n ? "showModal" : "close"]() : n || e.dispatchEvent(new CustomEvent("close")), e.hidden = !n, n && setTimeout(() => y == null ? void 0 : y.focus()), x({
        eventCategory: `modal_${o}`,
        eventAction: n ? "open" : `close${l}`,
        eventLabel: (e == null ? void 0 : e.getAttribute("aria-label")) || "modal"
      }));
    },
    [o, x]
  );
  return j(() => i(E, ""), [E, i]), // Paint backdrop with div so Safari 15 gets backdrop and so we can make the backdrop scrollable
  /* @__PURE__ */ m(
    "dialog",
    {
      ...t,
      className: O,
      hidden: !0,
      ref: f,
      onPointerDown: (n) => {
        var l;
        D = n.target === f.current, (l = t == null ? void 0 : t.onPointerDown) == null || l.call(t, n);
      },
      onPointerUp: (n) => {
        var u;
        const l = D, e = n.target === f.current;
        D = !1, (u = t == null ? void 0 : t.onPointerUp) == null || u.call(t, n), !h && l && e && i(!1);
      },
      onClose: B,
      onKeyDown: (n) => {
        var l;
        (l = t == null ? void 0 : t.onKeyDown) == null || l.call(t, n), n.key === "Escape" && (n.preventDefault(), h !== I && i(!1));
      },
      children: /* @__PURE__ */ U("div", { ...v, className: R, ref: M, children: [
        !!w && /* @__PURE__ */ m(
          K,
          {
            "aria-label": w,
            className: s.close,
            onClick: () => i(!1),
            variant: "unset",
            icon: /* @__PURE__ */ m(q, {})
          }
        ),
        c
      ] })
    }
  );
}), X = Object.assign(T, {
  Footer: N(function({ className: t, ...c }, a) {
    return /* @__PURE__ */ m("div", { ...c, className: C(s.footer, t), ref: a });
  })
});
export {
  X as Modal,
  T as ModalComp
};
//# sourceMappingURL=modal.js.map
